const shape = {
  borderRadius: 4
};
export {
  shape as default
};
//# sourceMappingURL=shape.js.map
